'use strict'
module.exports = {
  dev: {
    passport: 'https://test-passport.czur.cc',
    app: 'https://test.czur.cc/api',
    internal: 'https://inner-dubbo.czur.cc',
    loginCheck: 'https://test-passport.czur.cc/loginCheck.do?Channel=ALL&service=',
    starryAPI: 'https://test0927-starry.czur.cc/api',
    starryWeb: 'https://local-starry.czur.cc/starry.html',
    otherHost: 'https://natest.czur.cc',
    channel: 'CN'
  },
  dev_us: {
    passport: 'https://test-passport.czur.cc',
    app: 'https://test.czur.cc/api',
    internal: 'https://inner-dubbo.czur.cc',
    loginCheck: 'https://test-passport.czur.cc/loginCheck.do?Channel=ALL&service=',
    starryAPI: 'https://testna-starry.czur.cc/api',
    starryWeb: 'https://local-starry.czur.cc/starry.html',
    otherHost: 'https://cntest.czur.cc',
    channel: 'CN'
  },
  dev_prd: {
    passport: 'https://passport.czur.cc',
    app: 'https://www.czur.cc/api',
    internal: 'https://internal.czur.cc',
    loginCheck: 'https://passport.czur.cc/loginCheck.do?Channel=ALL&service=',
    starryAPI: 'https://starry-api2.czur.cc/api',
    starryWeb: 'https://local-starry.czur.cc/starry.html',
    otherHost: 'https://us.czur.cc',
    channel: 'CN'
  },
  test: {
    passport: 'https://test-passport.czur.cc',
    app: 'https://test.czur.cc/api',
    internal: 'https://inner-dubbo.czur.cc',
    loginCheck: 'https://test-passport.czur.cc/loginCheck.do?Channel=ALL&service=',
    starryAPI: 'https://test0927-starry.czur.cc/api',
    starryWeb: 'https://test.czur.cc/starry.html',
    otherHost: 'https://natest.czur.cc',
    channel: 'CN'
  },
  test_us: {
    passport: 'https://test-passport.czur.cc',
    app: 'https://test.czur.cc/api',
    internal: 'https://inner-dubbo.czur.cc',
    loginCheck: 'https://test-passport.czur.cc/loginCheck.do?Channel=ALL&service=',
    starryAPI: 'https://testna-starry.czur.cc/api',
    starryWeb: 'https://test.czur.cc/starry.html',
    otherHost: 'https://cntest.czur.cc',
    channel: 'CN'
  },
  prd_cn: {
    passport: 'https://passport.czur.cc',
    app: 'https://www.czur.cc/api',
    internal: 'https://internal.czur.cc',
    loginCheck: 'https://passport.czur.cc/loginCheck.do?Channel=ALL&service=',
    starryAPI: 'https://starry-api2.czur.cc/api',
    starryWeb: 'https://www.czur.cc/starry.html',
    otherHost: 'https://us.czur.cc',
    channel: 'CN'
  },
  prd_us: {
    passport: 'https://passport.czur.cc',
    app: 'https://global.czur.cc/api',
    internal: 'https://internal.czur.cc',
    loginCheck: 'https://passport.czur.cc/loginCheck.do?Channel=ALL&service=',
    starryAPI: 'https://starry-global.czur.cc/api',
    starryWeb: 'https://www.czur.cc/starry.html',
    otherHost: 'https://cn.czur.cc',
    channel: 'US'
  }
}



// WEBPACK FOOTER //
// ./src/common/script/server.js